module.exports = __webpack_public_path__ + "img/interior_12.9382c9a4.jpg";